import './App.css'
import React, { Component } from 'react'
import './App.scss'
import { BrowserRouter as Router } from 'react-router-dom'
import Wizard from './components/wizard/Wizard'
import PropTypes from 'prop-types'
import { ChangePasswordViewModel } from './models/ChangePasswordViewModel'
import { UserProfileDataViewModel } from './models/UserDataViewModel'
import { getAppInsights } from './TelemetryService'
import TelemetryProvider from './TelemetryProvider'
export default class App extends Component {
  appInsights = null;
  render() {
    this.props.config.debounce=true
    return (
        <Router>
            <TelemetryProvider
          instrumentationKey={ this.props.config.instrumentationKey || '' }
          after={ () => {
            this.appInsights = getAppInsights()
          } }
        >
                <Wizard config={ this.props.config } />
            </TelemetryProvider>
        </Router>
    )
  }
}

App.propTypes = {
  config: PropTypes.shape( {
    routeDefaultUrl: PropTypes.string,
    logInUrl: PropTypes.string,
    logInApiUrl: PropTypes.string,
    editProfileUrl: PropTypes.string,
    editProfileApiUrl: PropTypes.string,
    registerUrl: PropTypes.string,
    registerApiUrl: PropTypes.string,
    forgotPasswordUrl: PropTypes.string,
    forgotPasswordApiUrl: PropTypes.string,
    updatePasswordUrl: PropTypes.string,
    updatePasswordApiUrl: PropTypes.string,
    changePasswordUrl: PropTypes.string,
    changePasswordUrlApiUrl: PropTypes.string,
    contactUsUrl: PropTypes.string,
    registerUrl: PropTypes.string,
    contractorsUrl: PropTypes.string,
    municipalUrl: PropTypes.string,
    loginTitle: PropTypes.string,
    dgContractorsUrl: PropTypes.string,
    ReturnUrl: PropTypes.string,
    changePasswordViewModel: PropTypes.instanceOf( ChangePasswordViewModel ),
    userProfileDataViewModel: PropTypes.instanceOf( UserProfileDataViewModel ),
    disablePhoneNumber: PropTypes.bool,
    debounce: PropTypes.bool,
    logOffUrl: PropTypes.string,
    instrumentationKey: PropTypes.string,
    mfaAskMeAgainUrl: PropTypes.string,
    mfaAskMeAgainTimeOut: PropTypes.number,
    launchDarklyClientKey: PropTypes.string,
    antiForgeryHeaderName: PropTypes.string
  } )
}